import React, { createContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Divider, Grid, Typography } from "@mui/material";
import EmployeePersonalDocuments from "./EmployeePersonalDocuments/EmployeePersonalDocuments";
import EmployeeAddress from "./EmployeeAddress/EmployeeAddress";
import EmployeeBankAccount from "./EmployeeBankAccount/EmployeeBankAccount";
import EmployeeDependents from "./EmployeeDependents/EmployeeDependents";
import EmployeeChangingDocuments from "./EmployeeChangingDocuments/EmployeeChangingDocuments";

import { EmployeeDataProps } from "./interfaces";
import { Container, StyledTable, AddDocumentContainer } from "./styles";
import { SPACING } from "../../_globalStore/redux/reducers/Theme/themeConstants";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";
import AddNewDocument from "../AddNewDocument/AddNewDocument";
import { DOCUMENT_CATEGORIES } from "../../utils/constants/constants";
import { DocumentCategoryRef } from "../../models/document-categories";

export const EmployeeDataContext = createContext<EmployeeDataProps>({
  employee: null,
  forManager: false,
});

const EmployeeDataAndMutaions = ({ employee, forManager }: EmployeeDataProps) => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    isLoadingPersonalDocs: false,
    isLoadingChangingDocs: false,
    shouldReloadDocs: false,
  });

  useEffect(() => {
    if (state.shouldReloadDocs)
      setState((state) => ({
        ...state,
        shouldReloadDocs: false,
      }));
  }, [state.shouldReloadDocs]);

  return (
    <>
      {employee && (
        <Container>
          <EmployeeDataContext.Provider value={{ employee, forManager }}>
            <Grid style={{ minWidth: "51%" }}>
              {employee && forManager && (
                <Grid style={{ display: "flex", alignItems: "center", padding: "10px 0px" }}>
                  <Typography variant="h6">{`${t(`common_words.documents`)}`}</Typography>
                  <AddDocumentContainer>
                    <AddNewDocument
                      buttonType="text"
                      openButtonKey="Add new document"
                      documentFieldsProps={{
                        category: DOCUMENT_CATEGORIES.EMPLOYMENT_DOCUMENTS as DocumentCategoryRef,
                        legalEntity: employee?.legalEntity,
                        employee: employee,
                      }}
                      readOnlyFields={{
                        isLegalEntityRO: true,
                        isCategoryRO: true,
                        isEmployeeRO: true,
                      }}
                      hideReadOnlyFields
                      handleNotifyParent={(document) =>
                        setState((state) => ({
                          ...state,
                          shouldReloadDocs: true,
                        }))
                      }
                    />
                  </AddDocumentContainer>
                </Grid>
              )}

              <LoadingOverlay loading={state.isLoadingChangingDocs || state.isLoadingPersonalDocs}>
                <StyledTable size="small">
                  <EmployeePersonalDocuments
                    updateParentLoading={(isLoading: boolean) =>
                      setState((state) => ({
                        ...state,
                        isLoadingPersonalDocs: isLoading,
                      }))
                    }
                    shouldReload={state.shouldReloadDocs}
                  />
                  <EmployeeChangingDocuments
                    updateParentLoading={(isLoading: boolean) =>
                      setState((state) => ({
                        ...state,
                        isLoadingChangingDocs: isLoading,
                      }))
                    }
                    shouldReload={state.shouldReloadDocs}
                  />
                </StyledTable>
              </LoadingOverlay>
            </Grid>

            {/* <Divider
              orientation="vertical"
              flexItem
            /> */}

            {/* <Grid
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px",
                minWidth: "40%",
              }}
            >
              <EmployeeAddress />

              <Divider
                orientation="horizontal"
                style={{ width: "90%", alignSelf: "center" }}
              />
              <EmployeeBankAccount />
              <Divider
                orientation="horizontal"
                style={{ width: "90%", alignSelf: "center" }}
              />

              <EmployeeDependents />
            </Grid> */}
          </EmployeeDataContext.Provider>
        </Container>
      )}
    </>
  );
};

export default EmployeeDataAndMutaions;
